import { generate } from "@qiiro/qiiro-smartdocument";

class Preview extends HTMLElement {
  private container;
  constructor() {
    super();
    this.container = document.createElement("div");
  }

  connectedCallback() {
    const result = generate(window.doc, [], {
      cssClass: "preview-variable",
    });
    this.container.innerHTML = result;
    this.appendChild(this.container);
  }

  set groups(groups: any) {
    const content = generate(window.doc, groups, {
      cssClass: "preview-variable",
    });
    this.container.innerHTML = content;
  }
}

export default {
  name: "qiiro-preview",
  clazz: Preview,
};
